import axiosInstance from './api.service'
import constants from '../constants/constants'

const endpointOrigin = "Product/";

const Save = async (model) => await axiosInstance.post(endpointOrigin + 'Save', model, {
    ...constants.REQUIRE_INTERCEPTORS,
    fileHandler: true
})

const Get = async (id) => await axiosInstance.get(endpointOrigin + `?id=${id}`, constants.REQUIRE_INTERCEPTORS)

const GetAll = async (companyId) => await axiosInstance.get(endpointOrigin + `GetAll?companyId=${companyId}`, constants.REQUIRE_INTERCEPTORS)

const GetAllForCategory = async (categoryId) => await axiosInstance.get(endpointOrigin + `GetAllForCategory?categoryId=${categoryId}`, constants.REQUIRE_INTERCEPTORS)

const Check = async (name, companyId) => await axiosInstance.get(endpointOrigin + `Check?name=${name}&companyId=${companyId}`, constants.REQUIRE_INTERCEPTORS)

const DeleteProductImage = async (productImageId) => axiosInstance.get(endpointOrigin + `DeleteProductImage?productImageId=${productImageId}`, constants.REQUIRE_INTERCEPTORS)

const DeleteProductVideo = async (productId, key) => axiosInstance.post(endpointOrigin + 'DeleteProductVideo', { productId: productId, key: key }, constants.REQUIRE_INTERCEPTORS)

const SetProductImageIncludeInSummary = async (productImageId, shouldInclude) => await axiosInstance.get(endpointOrigin + `SetProductImageIncludeInSummary?productImageId=${productImageId}&shouldInclude=${shouldInclude}`, constants.REQUIRE_INTERCEPTORS)

const SortSampleImages = async (sortOrders) => axiosInstance.post(`${endpointOrigin}SortSampleImages`, sortOrders, constants.REQUIRE_INTERCEPTORS);

export {
    Save,
    GetAll,
    GetAllForCategory,
    Get,
    Check,
    DeleteProductImage,
    DeleteProductVideo,
    SetProductImageIncludeInSummary,
    SortSampleImages,
}